import { useCallback, useState } from "react";

export default function useDialogPortalContainer(
  closest = "dialog, [data-modal-viewport]",
) {
  const [container, setContainer] = useState<HTMLElement | undefined>(
    undefined,
  );

  const triggerRef = useCallback(
    (node: HTMLElement | null) => {
      if (node) {
        setContainer(node.closest<HTMLElement>(closest) ?? undefined);
      }
      return () => setContainer(undefined);
    },
    [closest],
  );

  return { container, triggerRef };
}
